/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, Output, EventEmitter } from '@angular/core';
/**
 * Chat message component.
 *
 * @styles
 *
 */
@Component({
    selector: 'nb-chat-message-options-list',
    template: `
    <p class="sender" *ngIf="sender || date">{{ sender }} <time>{{ date  | date:'shortTime' }}</time></p>

    <div class="option-buttons-container row">
        <a *ngFor='let option of options'  class="col-md-8 col-sm-12 option-button" (click)="chooseOption(option.value)">{{option.text}}</a>
    </div> 
  `,
    styles: [
        `
        .option-button {
            max-width: 70%;
            display: block;
            padding: 10px;
            cursor: pointer;
        }

        .option-button:hover {
            color: white !important;    
            background-color: #92a2bd;
        }
   
      .option-buttons-container .option-button {
        border: #92a2bd 1px solid;
        color: #92a2bd;
        font-weight: bold;
      }
   
      .option-buttons-container .option-button:first-child {
        border-top: #92a2bd 1px solid;
        border-radius: 20px 20px 0 0;
      }
   
      .option-buttons-container .option-button:not(:first-child) {
         border-top: hidden;
      }
   
      .option-buttons-container .option-button:last-child {
       border-radius: 0 0 20px 20px;      
     `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NbChatMessageOptionsListComponent {

    /**
     * Message sender
     * @type {string}
     */
    @Input() sender: string;

    /**
     * List options
     * @type {any[]}
     */
    @Input() options: any[];

    /**
     * Message send date
     * @type {Date}
     */
    @Input() date: Date;

    /**
     * Message sent 
    */
    @Input() message: string;
    /**
     * Option clicked event 
    */
   @Output() optionClicked: EventEmitter<any> = new EventEmitter<any>();
   
   /**
    * To be called when the user clicks an option
    */
   chooseOption(value: string): void {
       this.optionClicked.emit({
            message: value
       });
   }

}
